import TextBody from "apps/website/components/base/Text/TextBody/TextBody";
import SectionImageAccordionList from "apps/website/components/section/SectionImageAccordionList/SectionImageAccordionList";

export default function SectionFAQ() {
  return (
    <div className="bg-brand">
      <SectionImageAccordionList
        theme="brand"
        title="Frequently asked questions"
        image={{
          src: "/images/landingPage/FAQ/faqs.webp",
          width: 1007,
          height: 1080,
        }}
        direction="reverse"
        accordionList={[
          {
            title: "How much does KatKin cost?",
            Content: <TextBody size={ 3 }>It all depends on your cat. Our daily serve pouches are personalised to your
              cat&apos;s individual calorie needs - so the price is personalised too. We&apos;ll calculate yours
              during sign-up, before you check out. To get started, tell us about your cat.</TextBody>,
          },
          {
            title: "Is KatKin suitable for kittens?",
            Content: <TextBody size={ 3 }>Our fresh meals are suitable for kittens from weaning. Our 100% real meat
              content is great for growing muscles and because all our meals are gently cooked, they are easy to digest
              and good for young stomachs as well.</TextBody>,
          },
          {
            title: "Is KatKin suitable for senior cats (aged 9+)?",
            Content: <><TextBody size={ 3 }>Yes, we&apos;ve formulated KatKin to be suitable for
              cats of all life stages, including senior cats.</TextBody>
            <TextBody size={ 3 }>Our recipes are 100% meat and packed full of highly-digestible protein.
              Protein plays an important role in the nutritional management of arthritis, which 90% of all cats over
              the age of 12 are likely to have.</TextBody>
            <TextBody size={ 3 }>Although cats of all ages can develop kidney disease, this is more commonly
              seen in senior cats. As KatKin is also suitable for kittens, calcium and phosphorus levels in our food may
              be slightly higher to account for kittens&apos; needs. This won&apos;t detract from meeting a
              senior cat&apos;s needs, but if your senior cat has kidney disease, they may need a reduced phosphorus
              diet and this should be discussed with their vet.</TextBody>
            </>,
          },
          {
            title: "How do I know my cat will love it?",
            Content: <><TextBody size={ 3 }>Because cats are born to eat real meat. Even fussy cats turn ravenous on
              KatKin:</TextBody>
            <TextBody size={ 3 }>“My cat is the fussiest eater I&apos;ve ever known! I&apos;ve gone through so many
              brands (and LOTS of money). Then I found KatKin. Every mealtime, he eats up every last crumb.”
              - Karen and Haro</TextBody>
            <TextBody size={ 3 }>In your trial box, you&apos;ll have a plan for how to switch. And our team of Cat
              Experts on call for help - all of them hardcore cat parents who&apos;ve switched their own cats. So
              we know your cat will love fresh. Let&apos;s go.</TextBody>
            </>,
          },
          {
            title: "Where do you deliver to?",
            Content: <TextBody size={ 3 }>Right now, we deliver to England, Wales and most of mainland Scotland. Because
              our food is fresh, it needs to arrive on your doorstep within 48 hours. That means we can&apos;t
              deliver to the Highlands and Islands or Northern Ireland. But stay tuned - we&apos;re working on it.
              All cats need fresh,
              after all.</TextBody>,
          },
          {
            title: "How do I store KatKin?",
            Content: <>
              <TextBody size={ 3 }>Store in the freezer. Defrost in the fridge. Each pouch stays fresh in the
                fridge for up to ten days. Serve within two days once open.</TextBody>
              <TextBody size={ 3 }>Why the freezer, not the cupboard? Because if your cat&apos;s food is
                in the cupboard, it&apos;s been heat-blasted and filled with preservatives for shelf life,
                not cat life. We gently cook to protect nutrients, then freeze to keep fresh.</TextBody>
            </>,
          },
          {
            title: "Can I cancel my deliveries at any time?",
            Content: <>
              <TextBody size={ 3 }>Yes. You can easily pause, cancel or delay your deliveries whenever you want, in your
                online account or by calling 020 4538 4144. No hidden charges. No contracts. Expect some protests
                from your cat though. They may not give up fresh without a fight.</TextBody>
            </>,
          },
        ]}
      />
    </div>
  );
}
